/**
 * 模块: SKU筛选组件
 * 职责: SKU选择器组件
 * 限制: 文件<280行, 函数<30行
 */

import React from 'react';
import { Space, Select } from 'antd';
import { SKU } from './types';

const { Option } = Select;

interface SKUFilterProps {
  skus: SKU[];
  selectedSKU: number | undefined;
  onChange: (value: number | undefined) => void;
}

const SKUFilter: React.FC<SKUFilterProps> = ({ skus, selectedSKU, onChange }) => {
  return (
    <Space style={{ marginBottom: 16 }}>
      <span>筛选SKU:</span>
      <Select
        style={{ width: 300 }}
        placeholder="选择SKU（不选则显示所有）"
        allowClear
        value={selectedSKU}
        onChange={onChange}
      >
        {skus.map(sku => (
          <Option key={sku.id} value={sku.id}>
            {sku.name} ({sku.asin})
          </Option>
        ))}
      </Select>
    </Space>
  );
};

export default SKUFilter;

